import * as busyCounter from '../../../../sharedmodules/action-creators/busy-counter';
import actions from '../../../../sharedmodules/actions-list';
import { handleError } from '../../../../sharedmodules/services/error-handlers';
import { pinSearch } from '../repositories/pinSearch';

export const pinSearchData = (getAccessToken, data) => async (dispatch) => {

    dispatch(busyCounter.increaseBusyCounter());

    try {

        const pinSearchResult = await pinSearch(getAccessToken, data);
        dispatch({
            data: pinSearchResult,
            type: actions.GET_PIN_SEARCH_DATA,

        });

    } catch (error) {

        handleError(error);

    } finally {

        dispatch(busyCounter.decreaseBusyCounter());

    }

};
